/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PinCompanyListRequestFromJSON(json) {
    return PinCompanyListRequestFromJSONTyped(json, false);
}
export function PinCompanyListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        companyListIds: !exists(json, 'company_list_ids') ? undefined : json['company_list_ids']
    };
}
export function PinCompanyListRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        company_list_ids: value.companyListIds
    };
}
